if (!customElements.get("free-gift")) {
  class FreeGift extends HTMLElement {
    constructor() {
      super();

      // Options
      this.options = {
        enabled: false,
        threshold: 7500,
        cart_total: 0,
        max_gifts: 1,
      };

      // Get options from element data and combine with this.options
      if (this?.dataset?.options) {
        const dataOptions = JSON.parse(this.dataset.options);
        this.options = {
          ...this.options,
          ...dataOptions,
        };
      }

      // selectors
      this.selectors = {
        content: document.querySelector("[data-free-gift-content]"),
        cartItems: document.querySelector("cart-items"),
        cartDrawer: document.querySelector("cart-drawer"),
      };
    }

    /**
     * Update the free gift
     * @param state {object}: state object received from cart update (cart.js)
     */
    update(state) {
      if (!state) {
        return false;
      }

      // get total price from state
      const { total_price } = state;
      const cart_total = total_price - this.options.giftcards_value;

      if (this.options.threshold < cart_total && this.options.enabled) {
        this.classList.remove("free-gift--hidden");
        document.querySelector("[data-free-gift-item]").checked = true;
        this.updateGift(
          document
            .querySelector("[data-free-gift-item]")
            .getAttribute("data-free-gift-item"),
          true,
          state
        );
      } else {
        this.classList.add("free-gift--hidden");
        this.updateGift(null, false, state);
      }
    }

    /**
     * Sections to render after cart update
     * @returns {object}
     */
    getSectionsToRender() {
      return [
        {
          id: "main-cart-items",
          section: document.getElementById("main-cart-items").dataset.id,
          selector: ".js-cart-item-contents",
        },
        {
          id: "main-cart-item-count",
          section: document.getElementById("main-cart-item-count").dataset.id,
          selector: ".js-cart-item-count",
        },
        {
          id: "main-cart-footer",
          section: document.getElementById("main-cart-footer").dataset.id,
          selector: ".js-cart-footer-contents",
        },
        {
          id: "cart-icon-bubble",
          section: "cart-icon-bubble",
          selector: "[data-cart-icon-bubble]",
        },
      ];
    }

    /**
     * Get section Inner html
     * @param {string} html
     * @param {string} selector
     * @returns DOM
     */
    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector(selector).innerHTML;
    }

    /**
     * Add gift product to the cart
     * @param {string} id: variant id received from cart update (cart.js), if null remove all
     * @param {boolean} add: true or false
     * @param {object} state: state object received from cart update (cart.js)
     */
    updateGift(id, add = true, state) {
      if (!id && add == true) {
        return false;
      }
      return new Promise((resolve, reject) => {
        try {
          (async () => {
            // Add loader
            document.querySelector("cart-items").enableLoading();

            // Variables
            let sections;
            id = parseFloat(id);

            // Get all cart information
            let cart = state;
            if (!cart) {
              cart = await fetch(`${routes.cart_url}`, { ...fetchConfig() });
              cart = await cart.json();
            }

            // Current gift items form cart
            let currentGiftItem = cart.items.filter(
                (item) => item.properties._free_gift == true && item.id == id
              ),
              otherGiftItems = cart.items.filter(
                (item) => item.properties._free_gift == true && item.id != id
              ),
              maxOtherGiftItems = add
                ? this.options.max_gifts - 1
                : this.options.max_gifts;

            // If no id and adding == false remove all gift items
            if (!id && !add) {
              maxOtherGiftItems = 0;
            }

            // Capture update items
            let updateItems = {},
              disableItems = [];

            if (
              currentGiftItem.length >= 1 &&
              currentGiftItem[0].quantity != 1
            ) {
              updateItems[`${currentGiftItem[0].key}`] = add ? 1 : 0;
            }

            otherGiftItems.forEach((item, index) => {
              if (index >= maxOtherGiftItems) {
                updateItems[`${item.key}`] = 0;
                disableItems.push(item);
              }
            });

            // Update UI Disable free gifts if needed (will be removed with update fetch)
            disableItems.forEach((item) => {
              let giftCartItem = document.querySelector(
                `#free-gift-item-${item.id}`
              );
              if (giftCartItem) {
                giftCartItem.checked = false;
              }
            });

            // Update current gift items in cart;
            if (Object.keys(updateItems).length > 0) {
              const body = JSON.stringify({
                attributes: {
                  "free-gift": add,
                },
                updates: updateItems,
                sections: this.getSectionsToRender().map(
                  (section) => section.section
                ),
                sections_url: window.location.pathname,
              });
              cart = await fetch(`${routes.cart_update_url}`, {
                ...fetchConfig(),
                ...{ body },
              });
              cart = await cart.json();
              sections = cart.sections;
            }

            // Add new gift items to cart
            if (add && currentGiftItem.length == 0) {
              const body = JSON.stringify({
                attributes: {
                  "free-gift": true,
                },
                items: [
                  {
                    id: parseFloat(id),
                    quantity: 1,
                    properties: {
                      _free_gift: true,
                    },
                  },
                ],
                sections: this.getSectionsToRender().map(
                  (section) => section.section
                ),
                sections_url: window.location.pathname,
              });
              cart = await fetch(`${routes.cart_add_url}`, {
                ...fetchConfig(),
                ...{ body },
              });
              cart = await cart.json();
              sections = cart.sections;
            }

            // Get latest cart state after all operations
            cart = await fetch(`${routes.cart_url}`, { ...fetchConfig() });
            cart = await cart.json();

            // Update HTML
            if (
              Object.keys(updateItems).length > 0 ||
              (add && currentGiftItem.length == 0)
            ) {
              this.getSectionsToRender().forEach((section) => {
                const elementToReplace =
                  document
                    .getElementById(section.id)
                    .querySelector(section.selector) ||
                  document.getElementById(section.id);
                if (elementToReplace) {
                  elementToReplace.innerHTML = this.getSectionInnerHTML(
                    sections[section.section],
                    section.selector
                  );
                }
              });
            }

            // Remove loader
            document.querySelector("cart-items").disableLoading();

            // Resolve with latest cart state
            resolve(cart);
          })();
        } catch (error) {
          reject(error);
        }
      });
    }
  }

  window.FreeGift = FreeGift;

  customElements.define("free-gift", FreeGift);
}
